import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'AttachmentCache';

class AttachmentCache extends CacheBase2 {

    initialize() {
        this._name = _name;
    }

    /**
     * Returns all documents for a given jid, or [] if not cached.
     * Engine calls clear() on setEntry — stale data is never returned.
     * NOTE: BE uses 'rid' as generic foreign key — in Jerny context rid === jid.
     * @param {string} jid
     * @returns {object[]}
     */
    getByJid = (jid) => {
        try {
            return this._items.filter((d) => d.rid === jid);
        } catch (error) {
            this.logError('getByJid', error.message);
            return [];
        }
    };
}

const attachmentCache = new AttachmentCache();
export default attachmentCache;
